import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H5 } from 'syf-component-library/ui/typography';
import { Stack } from 'syf-component-library/ui/spacing';
import { translate } from '../../../../strings/i18n';
import { Description } from './subcomponents';
const AuthorizedUsersPrivileges = () => {
    const authUserPrivilegeList = [
        translate('addAuthUserScreen.spendAndUtilizeBenefits'),
        translate('addAuthUserScreen.physicalCardReceived'),
        translate('addAuthUserScreen.reportAccountHistory')
    ];
    return (_jsxs("div", { "data-testid": "auth-users-privileges", "data-cy": "message-box-container", children: [_jsx(H5, { weight: "bold", children: translate('addAuthUserScreen.eachAuthorizedUser') }), _jsx(Stack, { size: "large" }), authUserPrivilegeList.map(description => (_jsx(Description, { description: description }, description)))] }));
};
export default AuthorizedUsersPrivileges;
